import PaymentInformationModal from './PaymentInformationModal';

const Paywall1Modal = ({
  data,
  hideModal,
}: {
  data?: any;
  hideModal: () => void;
}) => (
  <PaymentInformationModal
    data={{ ...data, paywallVariant: 'paywall1' }}
    hideModal={hideModal}
  />
);

export default Paywall1Modal;
